import React, { useState } from "react";
import closeIcon from "../../../../assets/icons/closeIcon.svg";
import "./user-dashboard-all-objective-drawer-header.scss";
import BreadcrumbComponent from "../../../../common/components/breadcrumb-component/breadcrumb-component";

/**
 * UserDashboardAllObjectiveDrawerHeader
 *
 * Renders the header for the "All Objectives" drawer in the User Dashboard.
 * Provides a breadcrumb and a close action that collapses the drawer.
 *
 * Props
 * - setIsShowAllObjectiveDrawer: (visible: boolean) => void — callback to toggle drawer visibility
 * - handleOpenAddPopup: () => void — optional handler to open an add/create popup (currently unused)
 */
const UserDashboardAllObjectiveDrawerHeader: any = (props: any) => {
  const { setIsShowAllObjectiveDrawer } = props;
  const breadcrumbLink = [
    {
      label: "Objective Details",
    },
    {
      label: "User Details",
      handleClick: () => {},
    },
  ];
  const [crumbMappingOption] = useState<any>(breadcrumbLink);

  return (
    <div className="user-dashboard-all-objective-drawer-header">
      <div className="user-dashboard-all-objective-drawer-header-content">
        <div className="user-dashboard-all-objective-drawer-header-content-label">
          <BreadcrumbComponent
            breadcrumbLink={crumbMappingOption}
            showBackArrow={true}
            handleBackArrowClick={() => setIsShowAllObjectiveDrawer(false)}
          />
        </div>
        <div className="user-dashboard-all-objective-drawer-header-content-action">
          {/* Close button to collapse the drawer */}
          <button
            className="user-dashboard-all-objective-drawer-header-content-action-close-button"
            onClick={() => setIsShowAllObjectiveDrawer(false)}
          >
            <img
              src={closeIcon}
              alt="close"
              className="user-dashboard-all-objective-drawer-header-content-action-close"
            />
          </button>
        </div>
      </div>
    </div>
  );
};

export default UserDashboardAllObjectiveDrawerHeader;
